import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'tw-template-copyright',
    templateUrl: './template-copyright.component.html',
    styleUrl: './template-copyright.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TemplateCopyrightComponent {
    readonly translate = inject(TranslateService);

    readonly companyName = input<string>('Ticketpro');
    readonly year = input<number>(new Date().getFullYear());

    readonly copyrightLabel = computed(() =>
        `© ${this.year()} ${this.companyName()}. ${this.translate.currentLang === 'en' ? 'All rights reserved.' : `Tous droits réservés`}`
    );
}
